/**
 * Safe version of Array.prototype.toSorted.
 * Uses native toSorted if available, otherwise falls back to [...arr].sort().
 * Useful for older browsers/environments without toSorted support.
 */
export function toSortedSafe<T>(arr: T[], compareFn?: (a: T, b: T) => number): T[] {
  return typeof arr.toSorted === 'function' ? arr.toSorted(compareFn) : [...arr].sort(compareFn);
}
